import { fetchAPI } from "@/api/api"
import { fingerprintProPublicKeyDataSchema } from "@/schemas/account"
import { booleanParam } from "@/schemas/requestParams"
import type { FingerprintProPublicKeyData } from "@/types/account"
import { z } from "zod/v4"

const FINGERPRINT_PRO_PUBLIC_KEY_API_URL =
  "/exchange/member/playerService/getFingerprintProPublicKey"

const SUCCESS_STATUS = "0000"

// getFingerprintProPublicKey (SACRIC-1434 API contract): isExisted tells whether this account
// already has an Enterprise record; true makes the backend skip the Enterprise key without
// querying its record table. Missing or malformed counts as false.
const getFingerprintProPublicKeyRequestSchema = z.strictObject({
  isExisted: booleanParam
})

export interface FingerprintProPublicKeyRequest {
  isExisted: boolean
}

const fetch = {
  url: FINGERPRINT_PRO_PUBLIC_KEY_API_URL,
  handler: async (
    request: FingerprintProPublicKeyRequest
  ): Promise<FingerprintProPublicKeyData | undefined> => {
    const res = await fetchAPI({
      url: FINGERPRINT_PRO_PUBLIC_KEY_API_URL,
      // POST, not GET: axios drops the request body on GET, which would silently lose
      // isExisted. The backend accepts both methods.
      data: request,
      requestSchema: getFingerprintProPublicKeyRequestSchema,
      // { status: "9999", status_msg } when neither key is handed out or the lookup fails
      schema: fingerprintProPublicKeyDataSchema.or(
        z.object({ status: z.string(), status_msg: z.string() })
      )
    })

    if (!("trialPublicKey" in res) || res.status !== SUCCESS_STATUS) {
      console.warn("[getFingerprintProPublicKey] no public key handed out", res)
      return undefined
    }

    return res
  }
}

export default fetch
